export default "__VITE_ASSET__D2Nz8bKh__"